export class SponsorshipInfo {
    spId: number;
    spStatus: string;
    spMI: string;
    spLn: string;
    spFn: string;
    totalContribution: number;
    sponsorCode: string;
    parishName: string;
}
